export default __webpack_public_path__ + "static/media/Shape.17f5a268.svg";